import { put } from 'redux-saga/effects';
import { configs } from '../../constants/configs/configs';
import { push } from 'connected-react-router';
import { communicationPreferencesSagaActionTypes } from '../../constants/actionTypes/dashboardActionTypes';
import { dashboardLiteSagaActionTypes } from '../../constants/actionTypes/dashboardLiteActionTypes';
import { ssapSagaActionTypes } from '../../constants/actionTypes/ssapActionTypes';
import { startSpinner, stopSpinner } from '../../actions/common/actionCreators';
import { hideAllModals } from '../../actions/common/actionCreators';
import { SPINNER_MESSAGES_IDS } from '../../constants/common/miscellaneous';

const {
    FETCH_COMMUNICATION_PREFERENCES_FAILURE,
    FETCH_COMMUNICATION_PREFERENCES_START,
    FETCH_COMMUNICATION_PREFERENCES_SUCCESS
} = communicationPreferencesSagaActionTypes;


const {
    FETCH_DASHBOARD_MODELS_START,
    FETCH_DASHBOARD_MODELS_SUCCESS,
    FETCH_DASHBOARD_MODELS_FAIL,
    FETCH_PARTNER_BROKER_START,
    FETCH_PARTNER_BROKER_SUCCESS,
    FETCH_PARTNER_BROKER_FAIL
} = dashboardLiteSagaActionTypes;

const {
    BLOOD_RELATIONSHIPS_CHECK,
    BLOOD_RELATIONSHIPS_CHECK_SUCCESS,
    BLOOD_RELATIONSHIPS_CHECK_FAILURE,
    FETCH_AFFORDABILITY,
    FETCH_AFFORDABILITY_FAILURE,
    FETCH_AFFORDABILITY_SUCCESS,
    FETCH_ALL_BLOOD_RELATIONSHIPS,
    FETCH_ALL_BLOOD_RELATIONSHIPS_FAILURE,
    FETCH_ALL_BLOOD_RELATIONSHIPS_SUCCESS,
    FETCH_COUNTIES_FOR_ZIPCODE,
    FETCH_COUNTIES_FOR_ZIPCODE_FAILURE,
    FETCH_COUNTIES_FOR_ZIPCODE_SUCCESS,
    FETCH_COUNTRIES,
    FETCH_COUNTRIES_FAILURE,
    FETCH_COUNTRIES_SUCCESS,
    FETCH_ENROLLMENTS,
    FETCH_ENROLLMENTS_FAILURE,
    FETCH_ENROLLMENTS_SUCCESS,
    FETCH_SSAP_DATA,
    FETCH_SSAP_DATA_FAILURE,
    FETCH_SSAP_DATA_SUCCESS,
    FETCH_SSAP_PREVIOUS_DATA,
    FETCH_SSAP_PREVIOUS_DATA_FAILURE,
    FETCH_SSAP_PREVIOUS_DATA_SUCCESS,
    FETCH_TRIBES,
    FETCH_TRIBES_FAILURE,
    FETCH_TRIBES_SUCCESS,
    RECEIVE_SSNS,
    RECEIVE_SSNS_FAILURE,
    RECEIVE_SSNS_SUCCESS,
    SAVE_SSAP,
    SAVE_SSAP_FAILURE,
    SAVE_SSAP_SUCCESS,
    SUBMIT_SSAP,
    SUBMIT_SSAP_FAILURE,
    SUBMIT_SSAP_SUCCESS,
    VALIDATE_ADDRESS,
    VALIDATE_ADDRESS_FAILURE,
    VALIDATE_ADDRESS_SUCCESS
} = ssapSagaActionTypes;

export function* spinnerSaga({ type }) {
    switch(type) {
        case BLOOD_RELATIONSHIPS_CHECK:
        case VALIDATE_ADDRESS:
            yield put(startSpinner(SPINNER_MESSAGES_IDS.CHECKING_DATA));
            break;
        case SUBMIT_SSAP:
        case SAVE_SSAP:
            yield put(startSpinner(SPINNER_MESSAGES_IDS.SAVING_DATA));
            break;
        case FETCH_AFFORDABILITY:
        case FETCH_ALL_BLOOD_RELATIONSHIPS:
        case FETCH_COUNTIES_FOR_ZIPCODE:
        case FETCH_COUNTRIES:
        case FETCH_ENROLLMENTS:
        case FETCH_TRIBES:
        case FETCH_SSAP_DATA:
        case FETCH_SSAP_PREVIOUS_DATA:
        case RECEIVE_SSNS:
        case FETCH_DASHBOARD_MODELS_START:
        case FETCH_PARTNER_BROKER_START:
        case FETCH_COMMUNICATION_PREFERENCES_START:
            yield put(startSpinner(SPINNER_MESSAGES_IDS.LOADING_DATA));
            break;
        case BLOOD_RELATIONSHIPS_CHECK_SUCCESS:
        case FETCH_AFFORDABILITY_SUCCESS:
        case FETCH_ALL_BLOOD_RELATIONSHIPS_SUCCESS:
        case FETCH_COUNTIES_FOR_ZIPCODE_SUCCESS:
        case FETCH_COUNTRIES_SUCCESS:
        case FETCH_ENROLLMENTS_FAILURE:
        case FETCH_ENROLLMENTS_SUCCESS:
        case FETCH_TRIBES_SUCCESS:
        case FETCH_SSAP_DATA_SUCCESS:
        case FETCH_SSAP_PREVIOUS_DATA_SUCCESS:
        case RECEIVE_SSNS_SUCCESS:
        case SAVE_SSAP_SUCCESS:
        case SUBMIT_SSAP_SUCCESS:
        case VALIDATE_ADDRESS_FAILURE:
        case VALIDATE_ADDRESS_SUCCESS:
        case FETCH_DASHBOARD_MODELS_SUCCESS:
        case FETCH_PARTNER_BROKER_SUCCESS:
        case FETCH_COMMUNICATION_PREFERENCES_SUCCESS:
            yield put(stopSpinner());
            break;
        case BLOOD_RELATIONSHIPS_CHECK_FAILURE:
        case FETCH_AFFORDABILITY_FAILURE:
        case FETCH_ALL_BLOOD_RELATIONSHIPS_FAILURE:
        case FETCH_COUNTIES_FOR_ZIPCODE_FAILURE:
        case FETCH_COUNTRIES_FAILURE:
        case FETCH_TRIBES_FAILURE:
        case FETCH_SSAP_DATA_FAILURE:
        case FETCH_SSAP_PREVIOUS_DATA_FAILURE:
        case RECEIVE_SSNS_FAILURE:
        case SAVE_SSAP_FAILURE:
        case SUBMIT_SSAP_FAILURE:
        case FETCH_DASHBOARD_MODELS_FAIL:
        case FETCH_PARTNER_BROKER_FAIL:
        case FETCH_COMMUNICATION_PREFERENCES_FAILURE:
            yield put(stopSpinner());
            yield put(hideAllModals());
            yield put(push(configs.routes.FALLBACK));
            break;
    }
}